<template>
  <!-- Loading spinner while resolving a remote template from URL -->
  <div v-if="store.isLoadingTemplate && store.mode === 'dashboard'" class="app">
    <Header />
    <div
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: calc(100vh - 64px);
        color: #6b7280;
      "
    >
      <div class="loading-spinner" style="margin-bottom: 16px" />
      <div style="font-size: 16px">{{ store.loadingMessage || 'Resolving template...' }}</div>
    </div>
  </div>

  <!-- Dashboard mode -->
  <div v-else-if="store.mode === 'dashboard'" class="app">
    <Header />

    <div
      v-if="store.loadError"
      style="
        background-color: #fef2f2;
        color: #dc2626;
        padding: 12px 16px;
        border-radius: 8px;
        margin: 16px 24px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
      "
    >
      <span>{{ store.loadError }}</span>
      <button
        style="
          background: none;
          border: none;
          color: #dc2626;
          cursor: pointer;
          font-size: 18px;
          padding: 0 4px;
        "
        @click="store.clearLoadError()"
      >
        &times;
      </button>
    </div>

    <router-view />
  </div>

  <!-- Workflow mode -->
  <div v-else class="app">
    <Header />
    <div class="app-body">
      <Sidebar />
      <router-view />
    </div>
  </div>

  <ToastContainer />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useWorkflowStore } from './stores/workflow'
import { useServerEvents } from './composables/useServerEvents'
import Header from './components/Layout/Header.vue'
import Sidebar from './components/Layout/Sidebar.vue'
import ToastContainer from './components/ToastContainer.vue'

const store = useWorkflowStore()
const { connect } = useServerEvents()

onMounted(() => {
  store.initConfig()
  connect()
})
</script>
